import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './Equip.module.css';
import { DBCheckBox, DBIntField, DBTextField, DBTextArea } from '_components';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

class PatientCareCenterNoteSubjectivePTEquip extends React.Component {

    handleOxygenClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTNOTE ', 'NTNO', this.props.pk, 'NTSUBEQOXYGENTXT');
        }
    }

    handleAssistDevClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTNOTE ', 'NTNO', this.props.pk, 'NTSUBEQASSISTDEVTXT');
        }
    }

    handleOrthosisClick(selected) {
        if (!selected) {
            this.props.clearField(this.props.noteId, 'PTNOTE ', 'NTNO', this.props.pk, 'NTSUBEQORTHOSISTXT');
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_equip' name='Equipment' level={1}>

                <div className={styles.row}>
                    <label className={styles.col1}>Patient presents with:</label>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQIV'
                        className={styles.col2}
                        label='IV'
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQCATHETER'
                        className={styles.col3}
                        label='Catheter'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        {!this.props.oxygen &&
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.pk}
                                field='NTSUBEQOXYGEN'
                                label='Oxygen'
                                onClick={(selected) => this.handleOxygenClick(selected)}
                            />
                        }
                        {this.props.oxygen &&
                            <span>
                                <DBCheckBox
                                    noteId={this.props.noteId}
                                    entity='PTNOTE'
                                    entityKeyColumn='NTNO'
                                    entityKeyValue={this.props.pk}
                                    field='NTSUBEQOXYGEN'
                                    label='Oxygen device at'
                                    onClick={(selected) => this.handleOxygenClick(selected)}
                                />
                                <DBIntField
                                    noteId={this.props.noteId}
                                    entity='PTNOTE'
                                    entityKeyColumn='NTNO'
                                    entityKeyValue={this.props.pk}
                                    field='NTSUBEQOXYGENTXT'
                                    min={0}
                                    max={100}
                                    className={styles.oxygen}
                                />
                                <label className={styles.oxygen_label}>%</label>
                            </span>
                        }
                    </span>
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQTELEMETRY'
                        className={styles.col3}
                        label='Telemetry'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQPNEUMATIC'
                        className={styles.col2}
                        label='Pneumatic pump'
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQCOMPRESS'
                        className={styles.col3}
                        label='Compression Garmet'
                    />
                </div>

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <span className={styles.col2}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTNOTE'
                            entityKeyColumn='NTNO'
                            entityKeyValue={this.props.pk}
                            field='NTSUBEQASSISTDEV'
                            label='Assistive Device(s)'
                            className={styles.checkbox}
                            onClick={(selected) => this.handleAssistDevClick(selected)}
                        />
                        {this.props.assistDev &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.pk}
                                field='NTSUBEQASSISTDEVTXT'
                                className={styles.textfield}
                            />
                        }
                    </span>
                    <span className={styles.col3}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTNOTE'
                            entityKeyColumn='NTNO'
                            entityKeyValue={this.props.pk}
                            field='NTSUBEQORTHOSIS'
                            label='Orthosis'
                            onClick={(selected) => this.handleOrthosisClick(selected)}
                        />
                        {this.props.orthosis &&
                            <DBTextField
                                noteId={this.props.noteId}
                                entity='PTNOTE'
                                entityKeyColumn='NTNO'
                                entityKeyValue={this.props.pk}
                                field='NTSUBEQORTHOSISTXT'
                                className={styles.textfield}
                            />
                        }
                    </span>
                </div>
                <div className={styles.row}>
                    <div className={styles.col1_top}>Other:</div>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTNOTE'
                        entityKeyColumn='NTNO'
                        entityKeyValue={this.props.pk}
                        field='NTSUBEQOTHER'
                        className={styles.textarea}
                    />
                </div>

                </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let pk = parseInt(noteId.split("_")[1]);
    return {
        noteId: noteId,
        pk: pk,
        oxygen: state.entities.notes.PTNOTE[pk].NTSUBEQOXYGEN ? state.entities.notes.PTNOTE[pk].NTSUBEQOXYGEN : false,
        assistDev: state.entities.notes.PTNOTE[pk].NTSUBEQASSISTDEV ? state.entities.notes.PTNOTE[pk].NTSUBEQASSISTDEV : false,
        orthosis: state.entities.notes.PTNOTE[pk].NTSUBEQORTHOSIS ? state.entities.notes.PTNOTE[pk].NTSUBEQORTHOSIS : false
    };
}

const connectedPatientCareCenterNoteSubjectivePTEquip = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePTEquip);
export { connectedPatientCareCenterNoteSubjectivePTEquip as PatientCareCenterNoteSubjectivePTEquip };

